import { CountryCode, NumberFormat, formatNumber } from 'libphonenumber-js';
import { AlertOptions } from './conversation-channel.abstract';

export interface Translator {
  // eslint-disable-next-line
  instant(key: string | Array<string>, interpolateParams?: Object): string | any;
}

export function smsNotAvailableError(
  phoneNumber: string,
  email: string,
  country: string,
  translator: Translator,
): AlertOptions {
  if (!phoneNumber) {
    return <AlertOptions>{
      title: translator.instant('INBOX.CHAT.RESPOND_TO_LEAD_AT_EMAIL', {
        email: email,
      }),
    };
  }
  const countryCode = country.toUpperCase() as CountryCode;
  let phone = '';
  try {
    phone = formatNumber(phoneNumber, countryCode, 'NATIONAL' as NumberFormat);
  } catch (error) {
    // fallback to US if country code is not valid
    phone = formatNumber(phoneNumber, 'US' as CountryCode, 'NATIONAL' as NumberFormat);
  }
  if (email) {
    return <AlertOptions>{
      title: translator.instant('INBOX.CHAT.RESPOND_TO_LEAD_AT_PHONE_NUMBER_OR_EMAIL', {
        phone: phone,
        email: email,
      }),
    };
  }
  return <AlertOptions>{
    title: translator.instant('INBOX.CHAT.RESPOND_TO_LEAD_AT_PHONE_NUMBER', {
      phone: phone,
    }),
  };
}
